/**
 * Should this user get the workspace switcher regardless of
 * `accounts.workspaces_enabled`?
 *
 * The flag (migration 104, docs/workspaces-flag-rollout.md) hides the
 * multi-workspace UI because almost no ordinary customer uses it and it was a
 * bug source. It's flipped on by hand for the handful of real multi-workspace
 * users. That's the right default — for customers.
 *
 * Subcontractors break the assumption. A jobbing sub works for several firms, so
 * multi-workspace is their normal case, not an advanced feature — and neither
 * firm has any reason to have turned the flag on for them. Left alone they're
 * stranded in whichever workspace the middleware happened to pick, and with a
 * cleared cookie it's a login loop: resolveUserContext returns null for 2+
 * memberships with no cookie, and /workspaces/picker redirects to `/` when none
 * of the accounts is flagged.
 *
 * ── On matching the slug ──
 * CLAUDE.md anti-pattern #3 says gate on permissions, not on `roleSlug`, and it's
 * right — for AUTHORISATION. This is not an authorisation decision: it decides
 * whether a navigation affordance appears. Every workspace this unlocks is one
 * the user is already a member of, and /api/workspaces/switch re-verifies
 * membership server-side before it will set the cookie. The slug is also the
 * right key here for a second reason: `subbie` is exactly the string billing
 * uses to mean "free seat", so this lights up for precisely the population that
 * costs nothing and is expected to be in several workspaces.
 *
 * An account that builds a bespoke subcontractor-shaped custom role gets the
 * ordinary treatment: flip `workspaces_enabled` for them, same as any other
 * multi-workspace user.
 */
export const SUBBIE_ROLE_SLUG = 'subbie';

export function hasSubbieMembership(
  memberships: Array<{ role?: string | null }> | null | undefined,
): boolean {
  return (memberships || []).some((m) => m.role === SUBBIE_ROLE_SLUG);
}
